import React, { ReactNode } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { mb } from '../../common/theme/mbTokens';

type GrowConnectCardProps = {
  title?: string;
  /** Sits beside the title -- the success tick on the connected state. */
  titleIcon?: ReactNode;
  children?: ReactNode;
};

/**
 * The single frame every state of the flow lives in, matching the Stripe connect page: one
 * centred card, the provider's logo at the top, then the state's own title and body. Each state
 * renders its own card rather than the page slotting bodies into one, so a state stays a single
 * self-contained component.
 */
export const GrowConnectCard = ({ title, titleIcon, children }: GrowConnectCardProps) => (
  <Grid
    container
    justifyContent="center"
    sx={{ p: mb.layout.cardPadding, flex: 1, minHeight: 0, minWidth: 0, overflowY: 'auto' }}>
    {/* my auto rather than alignItems centre: a body taller than the page then scrolls instead of
        having its top cut off. */}
    <Card sx={{ width: '100%', maxWidth: '600px', my: 'auto', borderRadius: '8px' }}>
      <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
        <Grid container flexDirection="column" alignItems="center" gap={2}>
          <img src="/images/growlogo.png" alt="Grow" width="160px" />
          {title && (
            <Grid container width="auto" alignItems="center" justifyContent="center" gap={1}>
              {titleIcon}
              <Typography variant="h6" fontWeight={700} textAlign="center">
                {title}
              </Typography>
            </Grid>
          )}
        </Grid>
        {children && (
          <Grid container flexDirection="column" gap={2} mt={3}>
            {children}
          </Grid>
        )}
      </CardContent>
    </Card>
  </Grid>
);
